import { render, staticRenderFns } from "./AddPanelModal.vue?vue&type=template&id=bccd133e&scoped=true&"
import script from "./AddPanelModal.vue?vue&type=script&lang=js&"
export * from "./AddPanelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccd133e",
  null
  
)

export default component.exports